export const DEFAULT_APP_VERSION = "dev"

export const DEFAULT_TRACES_SAMPLE_RATIO = 1
export const MIN_TRACES_SAMPLE_RATIO = 0
export const MAX_TRACES_SAMPLE_RATIO = 1

export const DEFAULT_TELEMETRY_SHUTDOWN_TIMEOUT_MS = 5000

export const DEFAULT_LOG_LEVEL = "info"
export const LOG_LEVELS = ["fatal", "error", "warn", "info", "debug", "trace", "silent"] as const

export const SPAN_EXPORT_MAX_QUEUE_SIZE = 2048
export const SPAN_EXPORT_MAX_BATCH_SIZE = 512
export const SPAN_EXPORT_SCHEDULED_DELAY_MS = 5000

export const LOG_EXPORT_MAX_QUEUE_SIZE = 2048
export const LOG_EXPORT_MAX_BATCH_SIZE = 512
export const LOG_EXPORT_SCHEDULED_DELAY_MS = 5000

export const OTLP_EXPORT_TIMEOUT_MS = 10000
export const METRIC_EXPORT_INTERVAL_MS = 60000
export const EXPORT_FAILURE_LOG_INTERVAL_MS = 60000

export const DEFAULT_READINESS_CHECK_TIMEOUT_MS = 2000
export const READINESS_RESPONSE_MARGIN_MS = 500
export const DEFAULT_READINESS_CACHE_TTL_MS = 1000
export const DEFAULT_SHUTDOWN_GRACE_PERIOD_MS = 10000

export const SERVICE_NAMESPACE = "mube"

export const SERVICE_NAMES = ["api", "worker", "web"] as const

export type ServiceName = (typeof SERVICE_NAMES)[number]

export const OTLP_TRACES_PATH = "/v1/traces"
export const OTLP_METRICS_PATH = "/v1/metrics"
export const OTLP_LOGS_PATH = "/v1/logs"

export const HTTP_CLIENT_ERROR_MIN_STATUS = 400
export const HTTP_SERVER_ERROR_MIN_STATUS = 500

export const SENTRY_REPLAY_SESSION_SAMPLE_RATE = 0
export const DEFAULT_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE = 0

export const STDOUT_FD = 1

export const ENTITY_ID_ATTRIBUTES = ["org.id", "member.id", "tour.id", "generation.id"] as const
